import React, { useState } from "react";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Breakpoints from "common/breakpoints";
import VideoList from "./VideoList";
import VideoDetails from "./VideoDetails";
import MobileViewVideoDetails from "./MobileViewVideoDetails";
import { EVideoListTab } from "../helpers";
import useStyles from "./styles";

interface IProps {
  videos: racehorse360.ITrackOpticsVideo[];
  selectedVideo: racehorse360.ITrackOpticsVideo;
  onChangeSelectedVideo: (value: racehorse360.ITrackOpticsVideo) => void;
  activeTab: EVideoListTab;
  onUpdateVideoList: () => void;
}

const TrackOpticsContent = (props: IProps) => {
  const {
    videos,
    selectedVideo,
    onChangeSelectedVideo,
    onUpdateVideoList,
    ...restProps
  } = props;

  const classes = useStyles();
  const theme = useTheme();
  const matchesDownSM600 = useMediaQuery(
    theme.breakpoints.down(Breakpoints.SM_600)
  );

  const [shouldOpenMobileVideoDetails, setShouldOpenMobileVideoDetails] =
    useState(false);

  const updateVideoList = () => {
    setShouldOpenMobileVideoDetails(false);
    onUpdateVideoList();
  };

  const handleCloseMobileVideoDetails = () => {
    setShouldOpenMobileVideoDetails(false);
  };

  const handleChangeSelectedVideo = (video: racehorse360.ITrackOpticsVideo) => {
    if (matchesDownSM600) {
      setShouldOpenMobileVideoDetails(true);
    }

    onChangeSelectedVideo(video);
  };

  return (
    <div className={classes.rootContent}>
      <VideoList
        videos={videos}
        selectedVideoId={selectedVideo?.id}
        onChangeSelectedVideo={handleChangeSelectedVideo}
      />
      <VideoDetails
        className={classes.videoDetailsDesktopView}
        selectedVideo={selectedVideo}
        onUpdateVideoList={updateVideoList}
        {...restProps}
      />

      {shouldOpenMobileVideoDetails && (
        <MobileViewVideoDetails
          onClose={handleCloseMobileVideoDetails}
          selectedVideo={selectedVideo}
          onUpdateVideoList={updateVideoList}
          {...restProps}
        />
      )}
    </div>
  );
};

export default React.memo(TrackOpticsContent);
